import React, { useEffect } from "react";
import { isDate, useWPAjax } from "../../../../../wp-utils/v1";
import formatDateAndAge from "../../../utils/formatDateAndAge";

const ApplicationForm = ({ data, isLoading, handleApprove, notice, page, auth }) => {
  const { user_id, full_name_en, father_name, mother_name, date_of_birth, gender, NID_NO, profession, education_qualification } = data;
  const { year_of_ssc_exam, school_of_ssc_exam, marital_status, spouse_name, no_of_children, childrens, present_address, permanent_address } = data;
  const { mobile_no, email, blood_group, ssc_roll, is_approved, payment_document, profile_pic, signature, ssc_certificate } = data;

  return (
    <>
      <div className="application-form p-5">
        <header className="flex bg-green-700 px-4 py-5">
          <div className="header_logo w-20">
            <img src="https://mmmbaa-bd.org/wp-content/uploads/2023/06/New-Project-1.webp" className="w-full" alt="" />
          </div>
          <div className="header_content flex flex-1 flex-col items-center justify-center text-center">
            <h2 className="text-2xl font-semibold text-white">Muladi Govt. Mahmudjan Model Secondary School Alumni Association</h2>
          </div>
        </header>
        <div className="text-center mt-3">
          <h3 className="mt-3 text-xl font-bold">{page ? (page === "member-applications" ? "Application Form" : "Member Information") : ""}</h3>
        </div>
        <div className="application_body mt-4">
          <div className="flex gap-5">
            <div className="profile-picture w-48">
              <img className="w-48" src={profile_pic} alt="" />
            </div>
            <div className="personal-details flex-1">
              <table className="w-full mb-0">
                <thead>
                  <tr className="bg-gray-300 text-left">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Applications{"'"}s Name</td>
                    <td className="font-normal">{full_name_en}</td>
                  </tr>
                </thead>
                <tbody>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Father{"'"}s Name</td>
                    <td className="font-normal">{father_name}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Mother{"'"}s Name</td>
                    <td className="font-normal">{mother_name}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Date of Birth</td>
                    <td className="font-normal">{isDate(date_of_birth) ? formatDateAndAge(date_of_birth) : ""}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">NID No.</td>
                    <td className="font-normal">{NID_NO}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Contact Mobile</td>
                    <td className="font-normal">{mobile_no}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">E-Mail</td>
                    <td className="font-normal">{email}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-semibold">Gender</td>
                    <td className="font-normal">{gender}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pb-1 pl-1 text-sm font-semibold">Home District</td>
                    <td className="pb-1 font-normal">{permanent_address?.district}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-5 flex gap-5">
            <div className="personal-details flex-1">
              <table className="mmmbaa_details w-full mb-0">
                <tbody>
                  <tr className="border-b-2 border-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Education Qualification</td>
                    <td className="font-normal">{education_qualification}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Profession</td>
                    <td className="font-normal">{profession}</td>
                  </tr>
                  <tr className="border-b-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">SSC Roll</td>
                    <td className="font-normal">{ssc_roll}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">SSC Year</td>
                    <td className="font-normal">{year_of_ssc_exam}</td>
                  </tr>
                  <tr className="border-b-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">School of SSC Exam</td>
                    <td className="font-normal">{school_of_ssc_exam}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">SSC Certificate</td>
                    <td className="!pl-2 font-normal">
                      {ssc_certificate && (
                        <a href={ssc_certificate} target="_blank" rel="noreferrer">
                          <svg width="18px" height="18px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <path fill="#444" d="M16 10h-5.5l-2.5 2.5-2.5-2.5h-5.5v6h16v-6zM4 14h-2v-2h2v2z" />
                            <path fill="#444" d="M10 6v-6h-4v6h-3l5 5 5-5z" />
                          </svg>
                        </a>
                      )}
                    </td>
                  </tr>
                  <tr className="border-b-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Marital Status</td>
                    <td className="font-normal">{marital_status}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Spouse Name</td>
                    <td className="font-normal">{spouse_name}</td>
                  </tr>
                  <tr className="border-b-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Is registration fee (Tk. 500) paid?</td>
                    <td className="font-normal">Yes</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Payment Document</td>
                    <td className="!pl-2 font-normal">
                      {payment_document && (
                        <a href={payment_document} rel="noreferrer" target="_blank">
                          <svg width="18px" height="18px" viewBox="0 0 16 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
                            <path fill="#444" d="M16 10h-5.5l-2.5 2.5-2.5-2.5h-5.5v6h16v-6zM4 14h-2v-2h2v2z" />
                            <path fill="#444" d="M10 6v-6h-4v6h-3l5 5 5-5z" />
                          </svg>
                        </a>
                      )}
                    </td>
                  </tr>
                  <tr className="border-b-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Blood Group</td>
                    <td className="font-normal">{blood_group}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">No. of Children</td>
                    <td className="font-normal">{no_of_children}</td>
                  </tr>
                  {no_of_children > 0 && (
                    <>
                      <tr className="border-b-white bg-gray-200 text-left text-sm">
                        <td className="ml-2 w-56 pl-1 text-sm font-bold" colSpan={4}>
                          Childrens
                        </td>
                      </tr>
                      <tr className="border-b-white bg-gray-200 text-left text-sm">
                        <td className="ml-2 w-56 pl-1 text-sm font-normal">{childrens?.[0]?.name}</td>
                        <td className="ml-2 w-56 pl-1 text-sm font-normal">{childrens?.[1]?.name}</td>
                        <td className="ml-2 w-56 pl-1 text-sm font-normal">{childrens?.[2]?.name}</td>
                        <td className="ml-2 w-56 pl-1 text-sm font-normal">{childrens?.[3]?.name}</td>
                      </tr>
                    </>
                  )}
                </tbody>
              </table>
            </div>
          </div>
          <div className="mt-5 flex gap-5">
            <div className="personal-details flex-1 ">
              <table className="w-full">
                <tbody>
                  <tr className="border-b-2 border-white bg-gray-300 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal" colSpan={2}>
                      Present Address
                    </td>

                    <td className="ml-2 w-56 pl-1 text-sm font-normal" colSpan={2}>
                      Permanent Address:
                    </td>
                  </tr>
                  <tr className="border-b-2 border-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Village/Town/Road/House/Flat:</td>
                    <td className="font-normal">{present_address?.village}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Village/Town/Road/House/Flat:</td>
                    <td className="font-normal">{permanent_address?.village}</td>
                  </tr>
                  <tr className=" border-b-2 border-white bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Post Office:</td>
                    <td className="font-normal">{present_address?.postOffice}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">Post Office:</td>
                    <td className="font-normal">{permanent_address?.postOffice}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">P.S./Upazila:</td>
                    <td className="font-normal">{present_address?.thana}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">P.S./Upazila:</td>
                    <td className="font-normal">{permanent_address?.thana}</td>
                  </tr>
                  <tr className="bg-gray-200 text-left text-sm">
                    <td className="ml-2 w-56 pl-1 text-sm font-normal"> District:</td>
                    <td className="font-normal">{present_address?.district}</td>
                    <td className="ml-2 w-56 pl-1 text-sm font-normal">District:</td>
                    <td className="font-normal">{permanent_address?.district}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div className="mmmbaa-signature mt-5 flex justify-end mr-3">{signature && <img className="w-48" src={signature} alt="signature" />}</div>
          {!is_approved && auth.user_id != user_id && (
            <div className="submit_action">
              <button disabled={isLoading} className="border-white button px-5 w-full py-3 bg-gray-800 text-white rounded hover:bg-gray-600" onClick={handleApprove}>
                Approve
              </button>
            </div>
          )}
          {notice && (
            <div className="mmmbaa_notice_wrapper py-2">
              <p>{notice}</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default ApplicationForm;
